import { useMasqueradeContext } from "@circle-react/contexts/masqueradeContext";
import { useBackendProps } from "@circle-react/providers";

export const useMasqueradeEnabledAndActive = () => {
  const { masquerade_referrer_url: masqueradeReferrerUrl } = useBackendProps();
  const { isBannerVisible } = useMasqueradeContext();

  return !!masqueradeReferrerUrl || isBannerVisible;
};
